module.exports = __webpack_public_path__ + "img/BNI_logo.da5a292c.png";